import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// index.html ships static SEO tags so crawlers that do not run JavaScript still get a
// preview. React Helmet owns the head once the app mounts, so clear the statics first to
// avoid duplicate description/og/twitter tags in the rendered DOM.
["meta[name='description']", "meta[name='robots']", "meta[name^='twitter:']", "meta[property^='og:']"].forEach(
  (selector) => document.head.querySelectorAll(selector).forEach((el) => el.remove()),
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
